<template>
  <nav
    :key="$route.path"
    aria-label="Breadcrumb"
    class="inline-block mr-4 text-sm bg-grey-2 py-1 px-2 rounded"
  >
    <ol class="flex flex-wrap">
      <li class="mr-2 flex-a">
        <a
          :href="options.logo_link"
          aria-label="University of Edinburgh website"
          class="focus-a"
          data-gtm-home-breadcrumb
          v-html="'Home'"
        />
        <span class="block ml-2 mt-px">></span>
      </li>
      <li
        v-for="(breadcrumb, i) in breadcrumbs"
        :key="breadcrumb.path.name"
        class="mr-2 flex-a"
        data-gtm-breadcrumb:w
      >
        <RouterLink
          v-if="breadcrumb.title"
          :to="breadcrumb.path"
          class="focus-a"
          :aria-label="breadcrumb.title"
          v-html="limitString(breadcrumb.title, stringLength)"
        />
        <span
          v-if="breadcrumbs.length - 1 !== i"
          class="block mt-px ml-2"
          v-html="'>'"
        />
      </li>
    </ol>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { limitString } from '@/mixins'

export default {
  name: 'Breadcumbs',

  mixins: [limitString],

  props: {
    category: {
      type: Object,
      default: () => {}
    },

    location: {
      type: Object,
      default: () => {}
    },

    post: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState(['touch', 'mobile', 'phone', 'isCampus', 'isLocation']),
    ...mapGetters(['level', 'options']),

    breadcrumbs() {
      if (this.isCampus || this.isLocation) {
        return [
          {
            path: { name: 'level' },
            title: 'Virtual visit'
          },
          {
            path: {
              name: 'campus-category',
              params: { level_id: this.level, category_id: this.category.slug }
            },
            title: this.category.title
          }
        ]
      } else {
        return [
          {
            path: { name: 'home' },
            title: 'Virtual visit'
          },
          {
            path: {
              name: 'guided-intro',
              params: { level_id: this.level, tour_id: 'guided-tour_tour' }
            },
            title: 'Take a guided tour'
          }
        ]
      }
    },

    stringLength() {
      const mq = this.$mq
      const l = this.isLocation
      switch (mq) {
        case 'xxl':
          return l ? 35 : 50
        case 'xl':
          return l ? 35 : 50
        case 'lg':
          return 80
        case 'md':
          return 55
        default:
          return 35
      }
    }
  }
}
</script>
